import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-[#1B2A4A] border-t border-white/10 py-6 px-4" data-id="element-46">
        <div className="max-w-2xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-sm text-[#F5F0E8]/50" data-id="element-47">
          <span data-id="element-48">© {new Date().getFullYear()} $56 Más No Te Salva</span>
          <span className="hidden sm:inline" data-id="element-49">•</span>
          <button onClick={() => setActiveModal('privacy')} className="hover:text-[#F5F0E8] transition-colors underline underline-offset-2" data-id="element-50">
            Política de Privacidad
          </button>
          <span className="hidden sm:inline" data-id="element-51">•</span>
          <button onClick={() => setActiveModal('terms')} className="hover:text-[#F5F0E8] transition-colors underline underline-offset-2" data-id="element-52">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-53">
        <p className="font-bold text-xl" data-id="element-54">Política de Privacidad</p>
        <p data-id="element-55">Última actualización: febrero 2026</p>

        <p className="font-bold mt-6" data-id="element-56">1. Información que recopilamos</p>
        <p data-id="element-57">
          Al comprar nuestro producto digital, recopilamos únicamente la
          información necesaria para procesar tu compra: nombre, dirección de
          correo electrónico y datos de pago. No recopilamos información
          innecesaria ni compartimos tus datos con terceros para fines de
          marketing.
        </p>

        <p className="font-bold mt-6" data-id="element-58">2. Uso de la información</p>
        <p data-id="element-59">Tu información se utiliza exclusivamente para:</p>
        <ul className="list-disc pl-6 space-y-1" data-id="element-60">
          <li data-id="element-61">Procesar y entregar tu compra</li>
          <li data-id="element-62">Enviarte el producto digital adquirido</li>
          <li data-id="element-63">Comunicarnos contigo sobre tu pedido si es necesario</li>
        </ul>

        <p className="font-bold mt-6" data-id="element-64">3. Protección de datos</p>
        <p data-id="element-65">
          Utilizamos medidas de seguridad estándar de la industria para proteger
          tu información personal. Los pagos se procesan a través de plataformas
          seguras y certificadas. No almacenamos datos de tarjetas de crédito en
          nuestros servidores.
        </p>

        <p className="font-bold mt-6" data-id="element-66">4. Cookies</p>
        <p data-id="element-67">
          Nuestro sitio puede utilizar cookies básicas para mejorar tu
          experiencia de navegación. No utilizamos cookies de rastreo
          publicitario.
        </p>

        <p className="font-bold mt-6" data-id="element-68">5. Tus derechos</p>
        <p data-id="element-69">
          Tienes derecho a solicitar acceso, corrección o eliminación de tus
          datos personales en cualquier momento.
        </p>
      </LegalModal>

      {/* Terms Modal */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-70">
        <p className="font-bold text-xl" data-id="element-71">Términos y Condiciones</p>
        <p data-id="element-72">Última actualización: febrero 2026</p>

        <p className="font-bold mt-6" data-id="element-73">1. Producto digital</p>
        <p data-id="element-74">
          "$56 Más No Te Salva" es un producto digital en formato PDF. Al
          completar tu compra, recibirás acceso inmediato para descargar el
          material. Este producto es para uso personal y no puede ser
          redistribuido, revendido ni compartido.
        </p>

        <p className="font-bold mt-6" data-id="element-75">2. Naturaleza educativa</p>
        <p data-id="element-76">
          Este producto tiene fines educativos e informativos. No constituye
          asesoría financiera, legal ni profesional. Los resultados pueden
          variar según la situación individual de cada persona.
        </p>

        <p className="font-bold mt-6" data-id="element-77">3. Política de reembolso</p>
        <p data-id="element-78">
          Debido a la naturaleza digital del producto, ofrecemos una garantía de
          satisfacción. Si no estás satisfecha con tu compra, puedes solicitar
          un reembolso dentro de los primeros 7 días después de la compra.
        </p>

        <p className="font-bold mt-6" data-id="element-79">4. Propiedad intelectual</p>
        <p data-id="element-80">
          Todo el contenido del producto, incluyendo textos, plantillas,
          calendarios y materiales imprimibles, está protegido por derechos de
          autor. Se otorga una licencia de uso personal e intransferible al
          comprador.
        </p>

        <p className="font-bold mt-6" data-id="element-81">5. Limitación de responsabilidad</p>
        <p data-id="element-82">
          No nos hacemos responsables de decisiones financieras tomadas
          basándose en el contenido de este producto. Cada persona es
          responsable de evaluar su propia situación y tomar decisiones
          informadas.
        </p>

        <p className="font-bold mt-6" data-id="element-83">6. Modificaciones</p>
        <p data-id="element-84">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios serán efectivos al momento de su publicación.
        </p>
      </LegalModal>
    </>;
}